import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import { LandingLayout, Loading } from "../../components";
import {
	btnStyle,
	inputStyle,
	LandingTitle,
} from "../../lib/styles/styleLibrary";
import mail from "../../assets/svg/message.svg";
import { Input } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useHistory } from "react-router";
import { ROUTES } from "../../settings/routes";
import { Toast, ValidateEmail } from "../../lib/helpers/helpers";
import { useSelector } from "react-redux";
import { getAuth } from "../../redux/reducers/authReducer";
import { useDispatch } from "react-redux";
import { forgotPassword } from "../../redux/actions/authentication";

const ResetWrapper = styled.div`
	${tw`sm:p-8! md:p-16! sm:max-w-md sm:mx-auto md:max-w-none md:mx-0`}

	@media (min-width: 769px) and (max-width: 1023px) {
		padding: 16px !important;
	}
`;

const ForgotPassword = (props) => {
	const history = useHistory();
	const dispatch = useDispatch();
	const auth = useSelector(getAuth);
	const [email, setEmail] = useState("");
	const [loading, setLoading] = useState(false);

	const handleForgot = (e) => {
		e.preventDefault();

		if (!ValidateEmail(email.trim())) {
			Toast.fire({
				icon: "error",
				title: `You must enter a valid email address`,
			});
			return;
		}
		const data = {
			email,
		};
		// console.log(data);
		setLoading(true);
		dispatch(forgotPassword(data));
	};

	useEffect(() => {
		try {
			if (!loading) {
				return;
			}
			setLoading(false);
			const { error, message, title } = auth;
			if (error) {
				Toast.fire({
					icon: "error",
					title: `${title}
					${message}`,
				});
			} else {
				Toast.fire({
					icon: "success",
					title: `${title}
					${message}`,
				});
				setTimeout(() => {
					history.push({
						pathname: ROUTES.LOGIN,
					});
				}, 1000);
			}
		} catch (error) {}
		// eslint-disable-next-line
	}, [auth]);

	return (
		<LandingLayout>
			<div tw="h-full flex! flex-col!">
				<ResetWrapper>
					<ArrowLeftOutlined
						tw="p-3 bg-gray-100 mb-12 rounded-full hover:bg-white"
						onClick={() => history.goBack()}
					/>

					<LandingTitle>
						Forgot <br />
						Password
					</LandingTitle>

					<div tw="pt-8">
						<p tw="text-lg">
							Please enter your email address to <br />
							request a password reset
						</p>
					</div>

					<div tw="w-full">
						<form tw="flex flex-col sm:w-full md:w-full xl:w-8/12 lg:w-9/12">
							<Input
								placeholder="Your email"
								type="email"
								value={email}
								css={inputStyle}
								onChange={(e) => setEmail(e.target.value)}
								prefix={
									<img
										src={mail}
										alt=""
										tw=" focus:opacity-100 hover:opacity-100 pr-2"
									/>
								}
							/>

							<button
								css={btnStyle}
								tw="mt-4 h-12"
								onClick={handleForgot}>
								{loading ? <Loading /> : "Send"}
							</button>
						</form>
					</div>
				</ResetWrapper>{" "}
			</div>
		</LandingLayout>
	);
};

export default ForgotPassword;
